import { useApiMutation } from "./use-api-mutation";

export function useAddUpsCarrier(shopId: string) {
	return useApiMutation("post", "/shops/{shopId}/carriers/ups/login/{shopId}", {
		notify: { success: false },
		onSuccess: (response) => {
			window.location.href = (response as unknown as { redirectUrl: string }).redirectUrl;
		},
		mapVariables: ({
			accountNumber,
			carrierType,
			carrierId,
		}: {
			accountNumber: string;
			carrierType: string;
			carrierId?: string;
		}) => ({
			params: {
				path: { shopId },
				query: {
					accountNumber,
					carrierId,
					carrierType,
				},
			},
			// TODO: type API
		}) as unknown,
	});
}
